import React from 'react';
// @ts-ignore
import { ButtonWithIcon } from '@els/els-react--button';
// @ts-ignore
import { ModalPanel } from '@els/els-react--modal-panel';
// @ts-ignore
import { Icon } from '@els/els-react--icon';

interface IAccountCenterModalProps {
    id: string;
    className: string;
    renderAs?: 'modal' | 'inline';
    isOpen: boolean;
    firstName: string;
    lastName: string;
    userEmail: string;
    organizationName: string;
    contentClassName?: string;
    actionLinksClassName?: string;
    onClose?: () => void;
    onChangeLocation?: () => void;
    onManageAccount: () => void;
    onSignOut: () => void;
}

interface IAccountCenterLinkProps {
    label: string;
    sprite: string;
    className: string;
    onClick: () => void;
}

const AccountCenterLink = ({
    label,
    sprite,
    className,
    onClick,
}: IAccountCenterLinkProps) => (
    <ButtonWithIcon
        sprite={sprite}
        iconRight
        type="link"
        className={className}
        onClick={onClick}
        size="x-small"
        linkIconSize="xs"
    >
        {label}
    </ButtonWithIcon>
);

const AccountCenterModal = ({
    id,
    className,
    renderAs = 'modal',
    isOpen,
    firstName,
    lastName,
    userEmail,
    organizationName,
    contentClassName = '',
    actionLinksClassName = '',
    onClose = () => {},
    onChangeLocation,
    onManageAccount,
    onSignOut,
}: IAccountCenterModalProps) => {
    const content = (
        <div
            className={`general-header__account-center-content ${contentClassName}`.trim()}
        >
            <h2
                className={`general-header__account-center-content__title${
                    renderAs === 'inline'
                        ? ' u-els-hide-visually'
                        : ' general-header__account-center-content__mobile-title'
                }`}
            >
                Account menu
            </h2>

            <div className="u-els-font-size-h5 general-header__account-center-content__name">{`${firstName} ${lastName}`}</div>

            <div className="general-header__account-center-content__email">
                {userEmail}
            </div>
            {organizationName && (
                <>
                    <h3 className="u-els-font-size-h5 general-header__account-center-content__location-title">
                        Location
                    </h3>
                    <div className="general-header__account-center-content__location-value">
                        {organizationName}
                    </div>
                </>
            )}
            {onChangeLocation && (
                <AccountCenterLink
                    label="Change location"
                    sprite={Icon.Sprites.UP_RIGHT}
                    className="general-header__account-center-content__change-location"
                    onClick={onChangeLocation}
                />
            )}
            <hr className="general-header__account-center-content__divider" />
            <div
                className={`general-header__account-center-content__action-links ${actionLinksClassName}`.trim()}
            >
                <AccountCenterLink
                    label="Manage account"
                    sprite={Icon.Sprites.UP_RIGHT}
                    className="general-header__account-center-content__action-link"
                    onClick={() => {
                        onManageAccount();
                        onClose();
                    }}
                />
                <AccountCenterLink
                    label="Sign out"
                    sprite={Icon.Sprites.LOG_OUT}
                    className="general-header__account-center-content__action-link"
                    onClick={() => {
                        onSignOut();
                        onClose();
                    }}
                />
            </div>
        </div>
    );

    if (renderAs === 'inline') {
        return content;
    }

    if (!isOpen) {
        return null;
    }

    return (
        <ModalPanel
            id={id}
            panelPosition="right"
            className={className}
            modalProps={{
                onClose,
                label: 'User account',
                messages: { CLOSE_MODAL: 'Close user account menu' },
            }}
        >
            {content}
        </ModalPanel>
    );
};

AccountCenterModal.defaultProps = {
    renderAs: 'modal',
    contentClassName: '',
    actionLinksClassName: '',
    onClose: () => {},
    onChangeLocation: undefined,
};

export default AccountCenterModal;
